import React, { useState, useEffect} from "react";

import { Link as RouterLink } from "react-router-dom";


import theme from "../../theme/theme.js";
import Footer from "../../components/Footer/Footer.js";

// Chakra imports
import {
  ChakraProvider,
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Link,
  Switch,
  Text,
  useColorModeValue,
  CircularProgress,
} from "@chakra-ui/react";


import { useAuth } from "../../contexts/auth";
import useGetPublicServices from "hooks/useGetPublicServices.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import { Separator } from "components/Separator/Separator.js";


function Home() {
  // Chakra color mode
  const titleColor = useColorModeValue("teal.300", "teal.200");
  const textColor = useColorModeValue("gray.400", "white");


  const { auth } = useAuth();
  const [ accPath, setAccPath ] = useState('');
  const [ errors, setErrors] = useState([]);

  const {
    services, 
    gettingServices, 
    setGettingServices, 
    gettingServicesReqSuccess
  } = useGetPublicServices({setErrors});

  useEffect(() => {
    setGettingServices(true);
  }, []);

  useEffect(() => {
    console.log(services);
  }, [services]);


  useEffect(() => {
    if (auth) {
      switch(auth.role) {
        case 'manager':
          setAccPath('/admin/account');
        break;
        case 'personnel':
          setAccPath('/personnel/account');
        break;
        case 'customer':
        default:
          setAccPath('/users/account');
        break;
      }
    }

  }, [auth]);


  return (
    <ChakraProvider theme={theme} resetCss={false} w="100%">
    
    <Flex style={{
      padding: "1rem",
      flexDirection:"row",
      justifyContent:"space-between",
      // backgroundColor: "#fff"
    }}>
      <Text style={{
        fontWeight: "bold",
        fontSize: "22",
        textAlign: "center",
        verticalAlign: "center",
        margin: "auto 0"
      }}>EasyChek 7 Auto Service</Text>
      <Button 
        variant="outline"
        color="white"
        bg="teal.300"
        type="link"
        _hover={{
          color: "teal.200",
          bg: "white",
        }}
        style={{
          marginLeft: "auto"
        }}>
          <RouterLink
            to={'/login'}>
          <Link as="span" fontWeight="bold">
            Login
          </Link>
          </RouterLink> 
        </Button>
    </Flex>

    <div style={{
      width: "100%",
      height: "100vh",
      position: "absolute",
      top: 0,
      zIndex: -1,
      paddingTop: "80px",
      paddingLeft: "20px",
      paddingRight: "20px",
      // backgroundColor: "#fff"
    }}>

      { gettingServices
        ? <div style={{
          position: "absolute",
          width: "200px",
          height: "200px",
          left: "50%",
          top: "50%",
          marginLeft: "-100px",
          marginTop: "-60px",
          textAlign: "center",
        }}>
          <CircularProgress 
            isIndeterminate 
            color="teal.300" 
          />
          <br/>
          <br/>
          <Text>Loading Services</Text>
        </div>
        : null
      }
    { services && gettingServicesReqSuccess 
      ? <Box textAlign="center">
        <Text 
          id="services"
          fontSize="32px"
          color="gray.700"
          fontWeight="bold"
          ms={{ sm: "8px", md: "0px" }}>Services</Text>
      <Flex direction="row" 
        justifyContent="center" 
        alignItems="start" 
        height="auto"
        flexWrap="wrap"
        padding="24px"
        >

         { services.map((s) => {
              return <Card
                key={`it-${s.id}`} 
                minH="180px"
              style={{
                maxWidth: "300px",
                margin: "12px 12px",
              }}>
                <CardBody>
                  <Flex direction="column"
                  width="100%">
                    <Flex direction="row" justifyContent="center">
                      <img 
                        src={`data:image/jpeg;base64,${s.cover}`} 
                        style={{
                          width:"32px", 
                          height:"32px",
                          margin:"4px", 
                          objectFit:"cover",
                        }}
                        alt={s.title}/>
                      <Text 
                        marginTop="6px"
                        fontSize="lg"
                        color="gray.700"
                        fontWeight="bold"
                        pb=".5rem"
                        textAlign="center">{s.title}
                      </Text>
                    </Flex>
                    <Separator></Separator>
                    <Text 
                      marginTop="8px"
                      textAlign="center"
                      width="100%">{s.description}
                    </Text>
                  </Flex>
                </CardBody>
              </Card>
            })}
      </Flex>
      </Box>
      : null
    }

      <div
        style={{
          position: "absolute",
          bottom: 0,
          width: "98vw"
        }}>
          <Footer />
      </div>
    </div>

    {/* <Box w="100%">
      <Box w="100%">
        <Box w="100%">
          <Flex position="relative" mb="40px">
            <Flex
              h={{ sm: "initial", md: "75vh", lg: "85vh" }}
              w="100%"
              maxW="400px"
              mx="auto"
              justifyContent="space-between"
              mb="30px"
              pt={{ sm: "100px", md: "0px" }}
            >
              <Flex
                alignItems="center"
                justifyContent="center"
                style={{ userSelect: "none" }}
                w={{ base: "100%", md: "100%", lg: "100%" }}
              >
                <Flex
                  direction="column"
                  w="100%"
                  background="transparent"
                  p="48px"
                  mt={{ md: "150px", lg: "80px" }} 
                >
                  <Heading color={titleColor} fontSize="32px" mb="10px" 
                    textAlign="center">
                    HomePage is Coming Soon
                  </Heading>
                  <Text
                    mb="36px"
                    ms="4px"
                    color={textColor}
                    fontWeight="bold"
                    fontSize="14px"
                    textAlign="center"
                  >
                    Under Construction
                  </Text>

                  <Flex
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      maxW="100%"
                      mt="0px"
                    >
                      <Text color={textColor} fontWeight="medium">
                        Proceed to 
                        <RouterLink
                          to={'/login'}>
                          
                        <Link
                          color={titleColor} as="span" ms="5px" fontWeight="bold">
                          Login
                        </Link>
                        </RouterLink> 
                      </Text>
                    </Flex>
                </Flex>
              </Flex>
            
            </Flex>
          </Flex>
        </Box>
      </Box>
      <Box px="24px" mx="auto" width="1044px" maxW="100%">
        <Footer />
      </Box>
    </Box> */}
  </ChakraProvider>
  );
}

export default Home;
